import React from 'react';
import { BarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/BarChart';
import { HorizontalBarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/HorizontalBarChart';
import { MultiMetricComparisonBarChartUiComponentProps } from './types';

export const MultiMetricComparisonBarChartUiComponent = (
  props: MultiMetricComparisonBarChartUiComponentProps
) => {
  const { isHorizontal, ...barChartProps } = props;

  if (isHorizontal) {
    return <HorizontalBarChart {...barChartProps} />;
  }

  return <BarChart {...barChartProps} />;
};
